module.exports = __webpack_public_path__ + "img/5.36ef1d91.png";